export const QUOTATION_NOTIFICATION_SETTINGS_QUERY = `
  issueQuotation { emails roles {id name} enabled enableOwner }
  requestQuotation { emails roles {id name} enabled }
`;
